export { default } from './LocalLoader';
